import { cloneDeep } from 'lodash';
import { transparentize } from 'polished';
import { colors } from './colors';
import {
  helperDarkGray,
  palette,
  primaries,
  rebrand,
  rebrandBlue,
  rebrandFushia,
  rebrandNude,
  rebrandPurple,
  rebrandSuccess,
  rebrandYellow,
  shadowColor,
  shadowSize,
} from './palette';
import defaultTheme from './themedefault';
import { CustomTheme } from './types';

const theme = cloneDeep(defaultTheme) as unknown as CustomTheme;

theme.name = 'atsFancy';

theme.palette = {
  ...theme.palette,
  ...palette,
  rebrand,
  rebrandBlue,
  rebrandNude,
  rebrandPurple,
  rebrandFushia,
  rebrandYellow,
  rebrandSuccess,
  helperDarkGray,
};

theme.palette.primary = theme.palette.primary.concat(primaries);
theme.palette.primary[0] = rebrand[1];

theme.palette.border = [
  theme.palette.primary[32], // 0: Border
  theme.palette.primary[22], // 1: Job content
  theme.palette.primary[39], // 2: acl wrapper
];

theme.palette.background = [
  theme.palette.primary[15], // 0: default text color
  theme.palette.primary[26], // 1: rating star color
  theme.palette.primary[29], // 2: header background
  theme.palette.primary[29], // 3: left menu background
  theme.palette.primary[28], // 4: animated loader color
  theme.palette.primary[14], // 5: comment header background
  theme.palette.primary[29], // 6: flowpaper toolbar background
  theme.palette.primary[14], // 7: flowpaper viewer background
  theme.palette.primary[14], // 8: flowpaper toolbar button background
  theme.palette.primary[14], // 9: single job background
  theme.palette.primary[29], // 10: layout wrapper background
  theme.palette.primary[14], // 11: main content background
  theme.palette.primary[14], // 12: application background
  theme.palette.primary[14], // 13: application attachment list background
  theme.palette.primary[43], // 14: profile list background
  theme.palette.primary[14], // 15: profile list item background
  theme.palette.red[0], // 16: profile list rejected item background
  theme.palette.grey[0], // 17: profile list item hover background
  '#f7fafe', // 18: right sidebar background
  theme.palette.rebrand[0], // 19: sandwich color
  theme.palette.primary[14], // 20: searchbox icon
  theme.palette.primary[14], // 21: dropdown popover background
  theme.palette.primary[14], // 22: sortwrapper background
  theme.palette.blue[2], // 23: initials circle background
  theme.palette.primary[31], // 24: status menu background
  theme.palette.primary[14], // 25: drag item background
  theme.palette.primary[14], // 26: job sort background
  theme.palette.primary[29], // 27: aside header background
  theme.palette.rebrandPurple[6], // 28: application list item selected
  theme.palette.primary[14], // 29: initials circle
  theme.palette.primary[37], // 30: left menu item selected
  theme.palette.primary[14], // 31: button background
  theme.palette.primary[14], // 32: checkbox background
  theme.palette.primary[14], // 33: expand handle background
  theme.palette.primary[14], // 34: Dropdown background
  theme.palette.primary[14], // 35: application search bar background
  theme.palette.primary[37], // 36: timeline item background
  theme.palette.primary[29], // 37: main padding background
  theme.palette.rebrandPurple[5], // 38: job status background
  theme.palette.primary[41], // 39: team acl wrapper background
  theme.palette.primary[14], // 40: modal background
  theme.palette.primary[42], // 41: preselection background
  theme.palette.green[0], // 42: preselection correct answer background
  theme.palette.primary[44], // 43: greybox background
  theme.palette.primary[14], // 44: searchbox input background
  theme.palette.primary[14], // 45: new tag background
  theme.palette.primary[14], // 46: input background
  theme.palette.primary[46], // 47: input disabled background
  theme.palette.primary[14], // 48: profile list item option background
  theme.palette.primary[14], // 49: flowpaper zoom button background
  theme.palette.primary[14], // 50: applications selection header background
  theme.palette.primary[46], // 51: userchip background
  theme.palette.primary[14], // 52: tabs background
  theme.palette.primary[30], // 53: no results background
  theme.palette.primary[0], // 54: renew button background
  theme.palette.primary[53], // 55: job tag background
  theme.palette.primary[54], // 56: table hover background
  theme.palette.primary[53], // 57: input addon background
  theme.palette.primary[29], // 58: profile image placeholder background
  theme.palette.primary[14], // 59: select box background
  theme.palette.rebrand[0], // 60: banner background
  theme.palette.rebrand[1], // 61: primary background
  theme.palette.primary[35], // 62: contact button background
  theme.palette.primary[32], // 63: unread background
  transparentize(0.95, theme.palette.primary[17]), // 64: job status ordering background
  theme.palette.primary[22], // 65: job button hover background
  theme.palette.primary[57], // 66: dropdown hover background
  theme.palette.grayscale[4], // 67: select tag background
  theme.palette.primary[14], // 68: select clear button under X
  theme.palette.primary[60], // 69: tag background
  theme.palette.primary[59], // 70: alert error background
  theme.palette.rebrandBlue[3], // 71: scroll background
  theme.palette.primary[65], // 72: team temp alert info background
  theme.palette.primary[66], // 73: bulk actions background
  theme.palette.primary[14], // 74: message background
  theme.palette.primary[57], // 75: alert info background
  theme.palette.primary[69], // 76: profile promo background
  theme.palette.primary[14], // 77: tooltip background
  theme.palette.primary[14], // 78: notification background
  theme.palette.primary[77], // 79: notification feature background
  theme.palette.primary[42], // 80: cover letter background
  theme.palette.primary[14], // 81: ordered job background
  theme.palette.primary[14], // 82: page selector button
  theme.palette.primary[14], // 83: ad type background
  theme.palette.primary[14], // 84: radio button background
  theme.palette.rebrand[0], // 85: radio button selected background
  theme.palette.primary[14], // 86: InputNumber background
  theme.palette.grayscale[8], // 87: InputNumber background (active)
  theme.palette.primary[14], // 88: Steps
  theme.palette.grayscale[4], // 89: Online interviews header
  theme.palette.grayscale[4], // 90: email template variable background
  theme.palette.primary[43], // 91: photo background
  theme.palette.primary[82], // 92 CV database highlight background
  theme.palette.primary[89], // 93 standout orange for loyaltyreport
  theme.palette.rebrand[1], // 94 standout purple for loyaltyreport
  theme.palette.primary[14], // 95 section background color
  theme.palette.primary[14], // 96 comment modal background
  theme.palette.primary[14], // 97: continue job notification body background
  theme.palette.rebrandBlue[7], // 98 advanced search apply button color
  theme.palette.rebrandBlue[6], // 99 advanced search apply button higlight color
  theme.palette.rebrandBlue[1], // 100 new header background color
  theme.palette.rebrandBlue[0], // 101 create profile modal background
  theme.palette.primary[14], // 102 create profile modal button background
  theme.palette.rebrandBlue[0], // 103 create profile modal disabled button background
  theme.palette.rebrandFushia[6], // 104: search button background
  theme.palette.rebrandFushia[5], // 105: search button background (hover)
  theme.palette.rebrandBlue[1], // 106: candidate profile modal header background
  theme.palette.rebrandBlue[0], // 107: actions background
  theme.palette.rebrandBlue[0], // 108: select item background
  theme.palette.primary[14], // 109: project container background
  theme.palette.primary[29], // 110: job background color
  theme.palette.rebrandBlue[0], // 111: job placeholder background color
  theme.palette.rebrandBlue[1], // 112: placeholder job hover color
  theme.palette.grey[1], // 113: serial number background
  theme.palette.rebrandBlue[1], // 114: serial number highlighted background
  theme.palette.rebrandBlue[0], // 115: light panel background
  theme.palette.primary[14], // 116: light panel card background
  theme.palette.rebrandBlue[0], // 117: social posting size shade
  theme.palette.rebrandBlue[2], // 118: social posting checked
  theme.palette.primary[90], // 119: social posting description
  theme.palette.rebrandBlue[0], // 120: package checked
  theme.palette.primary[14], // 121: job preview pill background
  theme.palette.primary[14], // 122: site logo background
  theme.palette.primary[14], // 123: profile editor secondary elements background
  theme.palette.rebrandYellow[1], // 124: hint warning variant
  theme.palette.primary[94], // 125: profile editor card
  theme.palette.primary[14], // 126: profile report card background
  theme.palette.primary[29], // 127: profile report row hover background
  theme.palette.rebrandYellow[3], // 128: ad package yellow pill background
  theme.palette.rebrandYellow[2], // 129: accented modal header and hover
  transparentize(0.8, theme.palette.rebrandYellow[5]), // 130: tag background
  theme.palette.grey[0], // 131: secondary tag background
  theme.palette.rebrandBlue[0], // 132: upsale section background
];

theme.palette.foreground = [
  theme.palette.primary[15], // 0: default text color
  theme.palette.primary[26], // 1: rating star color
  theme.palette.rebrand[0], // 2: left menu link color
  theme.palette.rebrand[0], // 3: left menu highlight link color
  theme.palette.rebrand[0], // 4: left menu selected link color
  theme.palette.rebrand[0], // 5: left menu link hover color
  theme.palette.primary[15], // 6: initials circle
  theme.palette.rebrand[0], // 7: divider text
  theme.palette.primary[15], // 8: default button text
  theme.palette.primary[20], // 9: faded text color
  theme.palette.rebrandBlue[11], // 10: status text color
  theme.palette.primary[23], // 11: profile list item option text color
  theme.palette.primary[45], // 12: dropdown hover color
  theme.palette.primary[48], // 13: disabled input text color
  theme.palette.primary[49], // 14: application list email
  theme.palette.primary[50], // 15: phone number color
  theme.palette.primary[35], // 16: promo divider text color
  theme.palette.primary[14], // 17: renew button text
  theme.palette.primary[35], // 18: hightlight color text
  theme.palette.primary[52], // 19: job tag text color
  theme.palette.primary[15], // 20: select text
  theme.palette.primary[14], // 21: banner text
  theme.palette.rebrand[0], // 22: primary color text
  theme.palette.primary[32], // 23: unread text
  theme.palette.rebrand[1], // 24: generic highlights
  theme.palette.primary[20], // 25: comment time
  theme.palette.primary[35], // 26: comment highlight
  theme.palette.grey[3], // 27: dark mode switch color
  theme.palette.primary[72], // 28: new application notification
  theme.palette.primary[74], // 29: notification text
  theme.palette.primary[76], // 30: notification feature icon
  theme.palette.primary[17], // 31: notification new application icon
  theme.palette.primary[74], // 32: notification feature text
  theme.palette.primary[14], // 33: package promo text
  theme.palette.primary[30], // 34: subtle divider
  theme.palette.primary[45], // 35: page selector button
  theme.palette.primary[0], // 36: radio primary color
  theme.palette.primary[29], // 37: radio button selected foreground
  transparentize(0.92, theme.palette.primary[0]), // 38: radio focused shadow color,
  theme.palette.primary[0], // 39: radio border color
  transparentize(0.92, theme.palette.primary[0]), // 40: InputNumber focused shadow color
  colors.blue[800], // 41: generic link color
  theme.palette.primary[81], // 42: antd blue
  theme.palette.primary[35], // 43: job status foreground
  theme.palette.primary[17], // 44: job status ordered foreground
  theme.palette.blue[5], // 45: email template variable foreground
  theme.palette.red[2], // 46: template editor invalid color
  theme.palette.primary[35], // 47 CV database highlight foreground
  theme.palette.primary[83], // 48 custom class for standout-text
  theme.palette.rebrand[1], // 49 standout orange for loyaltyreport
  theme.palette.rebrand[0], // 50 standout purple for loyaltyreport
  theme.palette.primary[87], // 51 border color for loyaltyreport
  theme.palette.rebrand[1], // 52: secondary color text
  theme.palette.primary[15], // 53 comment modal text color
  theme.palette.rebrand[1], // 54 comment modal text hover color
  theme.palette.rebrand[1], // 55: continue job notification title
  theme.palette.primary[15], // 56: continue job notification hide button text
  theme.palette.rebrand[1], // 57: continue job notification icon
  theme.palette.primary[15], // 58: application list item unread text
  theme.palette.rebrandBlue[7], // 59 secondary button higlight color
  theme.palette.rebrand[1], // 60 secondary button text color
  theme.palette.rebrandBlue[9], // 61 active input text color
  theme.palette.rebrandBlue[6], // 62 advanced search label color
  theme.palette.rebrandBlue[9], // 63 advanced search link button text color highlight
  theme.palette.primary[14], // 64: search & advanced search button text color
  theme.palette.grey[1], // 65: side-note or acccent
  theme.palette.rebrandBlue[7], // 66: candidate profile card (seen)
  theme.palette.green[4], // 67: candidate profile card (unlocked)
  theme.palette.rebrand[1], // 68: candidate profile card icons
  theme.palette.rebrandBlue[6], // 69: info accents and modal header
  theme.palette.rebrandBlue[10], // 70: create profile heading text color
  theme.palette.rebrandBlue[6], // 71: new header text color
  theme.palette.rebrandBlue[7], // 72: profile list profile name
  theme.palette.rebrandBlue[6], // 73: create profile modal title
  theme.palette.rebrand[0], // 74: create profile modal button text
  theme.palette.rebrandBlue[3], // 75: create profile modal button border color
  theme.palette.rebrand[1], // 76: create profile modal cancel
  theme.palette.rebrandBlue[6], // 77: link button text color
  theme.palette.rebrandFushia[6], // 78: icons colors and highlights
  theme.palette.rebrandFushia[6], // 79: modal close button color
  theme.palette.rebrandFushia[5], // 80: close button (hover) & secondary button
  theme.palette.rebrandBlue[10], // 81: heavy accent & button with brand illustration
  theme.palette.grey[6], // 82: descriptions
  theme.palette.grey[4], // 83: date info with less accent
  theme.palette.grey[3], // 84: disabled icons color
  theme.palette.rebrandBlue[7], // 85: select hover text color
  theme.palette.rebrand[1], // 86: project and job brand color variation
  theme.palette.rebrandBlue[6], // 87: project pencil icon, show more icon
  theme.palette.rebrandBlue[7], // 88: project actions color
  theme.palette.primary[90], // 89: greyed out job text
  theme.palette.primary[15], // 90: candidate count text color
  theme.palette.rebrandBlue[8], // 91: placeholder job hover text color
  theme.palette.rebrand[1], // 92: publish and renew buttons color
  theme.palette.rebrand[1], // 93: publish button hover color
  theme.palette.rebrandBlue[5], // 94: application comments icon color
  theme.palette.rebrand[1], // 95: application buttons and actions
  theme.palette.rebrandYellow[3], // 96: link accent color
  theme.palette.rebrandYellow[5], // 97: link accent color hover
  theme.palette.grey[4], // 98: serial number text
  theme.palette.rebrandBlue[6], // 99: serial number highlighted text
  theme.palette.rebrandBlue[10], // 100: heading color
  theme.palette.rebrandBlue[6], // 101: light text color
  theme.palette.primary[90], // 102: social posting description
  theme.palette.rebrandBlue[7], // 103: profile editor blue accent
  theme.palette.rebrandBlue[0], // 104: profile editor status bar
  theme.palette.rebrandFushia[6], // 105: new button primary color
  theme.palette.rebrandBlue[9], // 106: new button secondary color
  theme.palette.grayscale[5], // 107: disabled new button background color
  theme.palette.primary[93], // 108: post editor control button active
  theme.palette.rebrandYellow[1], // 109: profile editor status bar dirty
  theme.palette.rebrandBlue[9], // 110: profile editor status bar profile link
  theme.palette.primary[90], // 111: profile editor notice text
  theme.palette.primary[96], // 112: hint warning variant text
  theme.palette.rebrandBlue[0], // 113: profile editor card hover
  theme.palette.rebrandBlue[8], // 114: profile report views icon poslovi
  theme.palette.rebrandBlue[8], // 115: profile report views icon helloworld
  theme.palette.primary[14], // 116: profile report views icon helloworld
  theme.palette.grey[4], // 117: secondary tag text color
  theme.palette.rebrandBlue[7], // 118: link color
  theme.palette.rebrandBlue[5], // 119: link color hover
  theme.palette.rebrand[1], // 120: topbar dropdown item hover (.isoDropdownLink:hover)
  theme.palette.rebrandBlue[6], // 121: single application basic info icon colors
];

theme.palette.fontWeight = [
  '700', // 0: left menu highlight
];

theme.palette.borderRadius = [
  '10px 0px 0px 10px', // 0: application wrapper
  '7px', // 1: button
  '10px', // 2: profile list
  '0px 10px 10px 0px', // 3: right sidebar
  '0px 20px 20px 0px', // 4: left menu selected item
  '0px 20px 20px 0px', // 5: sort wrapper
  '20px 0px 0px 20px', // 6: filter wrapper
  '20px', // 7: last child filter wrapper
  '20px 0px 0px 20px', // 8: application search bar wrapper
  '20px 20px 20px 20px', // 9: application search bar no sort wrapper
  '20px 20px 20px 20px', // 10: filter no sort wrapper
  '10px', // 11: package order form container
  '10px', // 12: invoices (mobile)
  '8px', // 13: candidate search components
  '4px', // 14: candidate search buttons
  '4px', // 15: new design form elements
  '16px', // 16: job preview pill
  '8px', // 17: profile report card
];

theme.palette.borderColor = [
  theme.palette.primary[36], // 0: button border
  theme.palette.primary[36], // 1: profile list item button border
  theme.palette.primary[51], // 2: profile header bottom border
  theme.palette.primary[36], // 3: job tag border color
  theme.palette.primary[56], // 4: profile image placeholder border
  theme.palette.primary[36], // 5: select box border
  theme.palette.primary[62], // 6: tab border
  theme.palette.primary[73], // 7: new application notification
  theme.palette.primary[75], // 8: notification
  theme.palette.primary[45], // 9: page selector button
  theme.palette.primary[36], // 10: simple input
  theme.palette.rebrandBlue[7], // 11: secondary button border color (hover)
  theme.palette.rebrand[1], // 12: secondary button border color
  theme.palette.rebrandBlue[9], // 13: input border highlight color
  theme.palette.dark[0], // 14: candidate profile card divider
  theme.palette.rebrandBlue[10], // 15: profile list CTA
  theme.palette.rebrandFushia[6], // 16: secondary button
  theme.palette.rebrandFushia[5], // 17: secondary button (hover)
  theme.palette.rebrandBlue[3], // 18: select (hover&focus)
  theme.palette.rebrandYellow[5], // 19: hint warning variant
  theme.palette.grey[1], // 20: secondary tag border color
];

theme.palette.shadowStyle = [
  `${shadowSize[2]} ${shadowColor[1]}`, // 0: action button shadow
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 1: job shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 2: job hover shadow
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 3: main content shadow
  `${shadowSize[2]} ${shadowColor[0]}`, // 4: application wrapper shadow
  `${shadowSize[4]} ${shadowColor[2]}`, // 5: attachment list shadow
  `${shadowSize[3]} ${shadowColor[1]}`, // 6: attachment list hover shadow
  `${shadowSize[0]} ${shadowColor[1]}`, // 7: attachment list active shadow
  `0 3px 6px -4px rgba(83, 123, 213, 0.12)`, // 8: application filter shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 9: application filter hover shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 10: application filter focus shadow
  `${shadowSize[2]} ${shadowColor[0]}`, // 11: profile list shadow
  `${shadowSize[2]} ${shadowColor[0]}`, // 12: right sidebar shadow
  `0 3px 6px -4px rgba(83, 123, 213, 0.12)`, // 13: search bar shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 14: search bar hover shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 15: search bar focus shadow
  `${shadowSize[2]} ${shadowColor[0]}`, // 16: dropdown shadow
  `0 3px 6px -4px rgba(83, 123, 213, 0.12)`, // 17: sort shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 18: sort hover shadow
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 19: job sort wrapper shadow
  `${shadowSize[5]} ${shadowColor[1]}`, // 20: job sort wrapper hover shadow
  `${shadowSize[5]} ${shadowColor[1]}`, // 21: job sort wrapper focus shadow
  `${shadowSize[0]} ${shadowColor[1]}`, // 22: page selector button shadow
  `${shadowSize[7]} ${shadowColor[4]}`, // 23: header shadow
  `${shadowSize[7]} ${shadowColor[4]}`, // 24: search bar shadow
  `${shadowSize[2]} ${shadowColor[1]}`, // 25: search bar hover shadow
  `${shadowSize[10]} ${shadowColor[3]}`, // 26: input shadow style
  `${shadowSize[12]} ${shadowColor[1]}`, // 27: seller image shadow style
  `${shadowSize[2]} ${shadowColor[8]}`, // 28: pricelist highlight
  `${shadowSize[6]} ${shadowColor[1]}`, // 29: ad type shadow
  `${shadowSize[13]} ${shadowColor[10]}`, // 30: ad type shadow (hover)
  `${shadowSize[13]} ${shadowColor[10]}`, // 31: package order form container
  `${shadowSize[13]} ${shadowColor[10]}`, // 32: banner shadow
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 33: job shadow (mobile)
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 34: breadcrumg
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 35: invoice shadow (mobile)
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 36: continue job notification shadow
  `${shadowSize[16]} ${shadowColor[11]}`, // 37: advanced search shadow
  `${shadowSize[16]} ${shadowColor[12]}`, // 38: advanced search shadow hover
  `${shadowSize[17]} ${shadowColor[13]}`, // 39: search and location card shadow
  `0 10px 15px -3px rgba(125,59,236,.1), 0 4px 6px -2px rgba(125,59,236,.05)`, // 40: project container shadow
  'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))', // 41: profile editor item overflow shadow,
  '0px -3px 9px 0px #d1d0fa36', // 42: profile editor action bar
  `${shadowSize[18]} ${shadowColor[14]}, ${shadowSize[19]} ${shadowColor[15]}`, // 43: profile report card shadow
];

theme.palette.borderStyle = [
  '0px', // 0: header border
  `7px solid ${theme.palette.rebrand[0]}`, // 1: left menu selected item;
  '1px solid #e8e8e8', // 2: divider
  `1px solid ${theme.palette.primary[22]}`, // 3: light divider
  `1px solid ${theme.palette.primary[43]}`, // 4: preselection divider
  '1px solid #e8e8e8', // 5: select tag border
  `1px solid ${theme.palette.primary[36]}`, // 6: default button border
  `1px solid ${theme.palette.primary[68]}`, // 7: alert info border
  `1px solid ${theme.palette.primary[71]}`, // 8: tooltip border
  `1px solid ${theme.palette.primary[79]}`, // 9: menu divider
  `1px solid ${theme.palette.foreground[34]}`, // 10: subtle border
  '0px', // 11: breadcrumb
  `1px solid ${theme.palette.rebrandBlue[3]}`, // 12: input bottom border
  `1px solid ${theme.palette.rebrandBlue[3]}`, // 13 candidate profile card border (seen)
  `1px solid ${theme.palette.green[2]}`, // 14: candidate profile card (unlocked)
  '1px solid #0000000f', // 15: profile list table border, modal border
  `1px solid ${theme.palette.grey[0]}`, // 16: attached components divider
  `1px solid ${theme.palette.rebrandBlue[3]}`, // 17: hoverable site logo hover border
  `1px solid ${theme.palette.rebrandBlue[1]}`, // 18: profile editor borders
  `1px solid ${theme.palette.rebrandYellow[5]}`, // 19: candidate profile tag borders
];

theme.palette.mobile = ['991px', '1440px', '1537px'];

theme.palette.spacing = [
  '20', // 0: layout spacing
  '0', // 1: spacing between application and sidebar
];

theme.palette.size = [
  '45', // 0: header height
  '255', // 1: sidebar width
  '330', // 2: profile list
  '320', // 3: right sidebar width
  '140', // 4: rightsidebar comment input wrapper size
  '40', // 5: application search height
  '380', // 6: application search width
  '0', // 7: actions bar
  '0', // 8: application search actions width
  '280', // 9: profile list collapsed width
  '380', // 10: right floater size
  '40', // 11: banner size
  '10', // 12: scroll size
  '2', // 13: scroll size mobile
  '400', // 14: notification list on home page
  '57', // 15: small sidebar width
];
theme.sizes = {
  bigLetters: '0.9rem',
};

theme.palette.padding = [
  '0 16px 0 12px', // 0: left menu item padding
  '0 16px 0 20px', // 1: left menu item hover padding
  '0 16px 0 5px', // 2: left menu item selected padding
];

theme.palette.focusOutline = [
  '3px solid rgba(24, 144, 255, .06)', // 0: radio button focus style
];

theme.palette.opacity = [
  '0.06', // 0: candidate profile card divider
  '1', // 1: candidate profile card time information
];

theme.questionMarkTooltip = {
  color: colors.gray[500],
};

theme.primary = colors.fuchsia[600];
theme.secondary = colors.blue[900];
theme.background = {
  primary: '#fff',
  panel: colors.gray[50],
  panelSecondary: colors.blue[25],
  secondary: colors.blue[50],
};

theme.text = {
  primary: colors.blue[900],
  gray: colors.gray[600],
  fadedGray: theme.palette.foreground[9],
  fuchsia: colors.fuchsia[600],
  darkGray: colors.gray[800],
};

theme.select = {
  tag: {
    background: {
      default: colors.gray[50],
    },
    close: {
      color: {
        default: colors.blue[500],
      },
    },
  },
  notFoundContent: {
    text: {
      color: {
        default: 'unset',
      },
    },
  },
  filters: {
    border: {
      default: {
        color: colors.blue[100],
      },
      hover: {
        color: colors.fuchsia[100],
      },
      focus: {
        color: colors.fuchsia[100],
      },
    },
  },
};

theme.optionBox = {
  outline: {
    default: colors.blue[200],
    hover: colors.fuchsia[600],
    selected: colors.blue[500],
  },
  background: {
    default: 'transparent',
    borderless: colors.blue[50] + '85',
    filled: colors.gray[50],
    selected: colors.blue[50],
    gradient: colors.yellow[200],
    hover: {
      gradient: colors.fuchsia[600] + '26',
    },
  },
  separator: {
    default: colors.blue[200],
  },
  text: {
    color: {
      default: theme.text.primary,
    },
    background: {
      highlight: colors.blue[100],
    },
  },
  pill: {
    background: colors.blue[50],
    borderColor: colors.blue[200],
  },
  yellowPopover: {
    background: colors.yellow[100],
    color: {
      default: colors.yellow[900],
      light: colors.yellow[700],
    },
    borderColor: colors.yellow[300],
    boxShadow: `0 3px 6px -4px rgba(122, 99, 34, 0.18),
                0 6px 16px 0 rgba(122, 99, 34, 0.14),
                0 9px 28px 8px rgba(122, 99, 34, 0.1);`,
  },
};

theme.input = {
  padding: '8px 8px',
  fontSize: '0.8rem',
  background: {
    error: colors.red[50],
  },
};

theme.hint = {
  info: {
    background: colors.blue[50],
    color: colors.blue[500],
    border: colors.blue[500],
  },
  warning: {
    background: colors.yellow[100],
    color: colors.yellow[900],
    border: colors.yellow[400],
  },
  success: { background: colors.green[50], color: colors.green[700], border: colors.green[700] },
  error: {
    background: colors.red[100],
    color: colors.red[900],
    border: colors.red[400],
  },
};

theme.tag = {
  background: {
    default: colors.blue[50],
    nonClickable: colors.gray[50],
  },
  text: {
    color: {
      default: colors.blue[600],
      nonClickable: colors.gray[100],
    },
  },
  border: {
    default: colors.blue[200],
    nonClickable: colors.gray[100],
  },
};

theme.slider = {
  background: {
    default: colors.blue[900],
  },
  text: {
    color: {
      default: colors.blue[900],
    },
  },
  border: {
    default: colors.blue[900],
  },
  rail: {
    default: colors.blue[100],
  },
};

theme.preselection = {
  background: colors.blue[25],
  questionHover: colors.blue[25],
  border: {
    disabled: colors.gray[100],
    expanded: colors.blue[150],
    collapsed: theme.background.panel,
  },
  answer: {
    background: {
      preferable: colors.green[50],
      nonPreferable: colors.red[50],
    },
  },
  suggestedQuestion: {
    added: {
      borderColor: {
        regular: colors.blue[300],
        hovered: colors.blue[400],
      },
      background: {
        regular: colors.blue[50],
        hovered: colors.blue[100],
      },
      textColor: colors.blue[700],
    },
    notAdded: {
      borderColor: {
        regular: colors.gray[300],
        hovered: colors.gray[400],
      },
      background: {
        regular: '#FFFFFF',
        hovered: colors.gray[50],
      },
      textColor: colors.gray[700],
    },
  },
};

theme.socialPostingOption = {
  background: {
    default: theme.background.primary,
    selected: colors.blue[100],
  },
  circle: {
    default: colors.blue[50],
  },
};

theme.steps = {
  background: {
    active: colors.fuchsia[600],
    inactive: colors.fuchsia[100],
  },
};

theme.stars = {
  color: {
    full: colors.yellow[500],
    empty: colors.gray[200],
  },
};

theme.inviteFlow = {
  tooltipBackground: 'white',
  text: colors.blue[950],
  textMuted: colors.gray[600],
  textActive: colors.blue[950],
  stageBackground: `linear-gradient(120deg, ${colors.blue[50]} 33%, ${colors.fuchsia[50]} 100%)`,
  icon: colors.blue[700],
  track: colors.blue[200],
  accent: colors.fuchsia[600],
  accentStrong: colors.fuchsia[600],
  surface: 'white',
  placeholder: colors.blue[100],
  accept: colors.green[600],
  free: colors.green[600],
  declineBackground: colors.gray[100],
  rowBackground: 'white',
  rowBorder: colors.blue[100],
  newRowBackground: colors.green[50],
  newRowBorder: colors.green[300],
  newRowPlaceholder: colors.green[300],
};

theme.modal = {
  closeIcon: {
    background: 'white',
    color: colors.blue[600],
  },
  shadow: {
    default:
      '0px 16px 28px -3px hsla(222, 83%, 34%, 0.27), 0px 4px 4px 0px hsla(222, 83%, 34%, 0.15)',
  },
};

theme.statistic = {
  color: {
    title: theme.text.gray,
    value: '#000',
    prefix: '#000',
    suffix: '#000',
    dateIcon: colors.fuchsia[500],
  },
  selectionLevel: {
    track: colors.gray[100],
    label: theme.text.darkGray,
    reached: colors.blue[200],
    current: colors.blue[600],
    // `dark` for the count standing on `reached`, `light` for the one on `current`.
    count: {
      dark: colors.gray[900],
      light: '#FFFFFF',
    },
  },
  shadow: {
    statistic: '0px 4px 9px 0px rgba(3, 26, 106, 0.07)',
  },
};

theme.newRadioButtons = {
  border: colors.blue[200],
  text: colors.blue[900],
  background: colors.blue[50],
};

theme.newDiscountTable = {
  border: colors.blue[200],
  cellText: colors.blue[900],
  cellBackground: colors.blue[50],
};

theme.faqAccordion = {
  border: `1px solid ${colors.blue[150]}`,
  textColor: colors.blue[900],
};

theme.discountPicker = {
  background: 'white',
  borderRadius: '12px',
  borderColor: {
    blue: colors.blue[200],
    gray: colors.gray[200],
  },
  durationToggle: {
    background: colors.blue[50],
  },
  textColor: {
    primary: colors.blue[900],
    secondary: colors.blue[400],
    label: colors.gray[600],
  },
};

theme.highlightTag = {
  background: colors.yellow[300],
  color: colors.blue[900],
};

theme.toggle = {
  background: {
    default: colors.blue[100],
    indicator: colors.blue[900],
    hover: colors.blue[150],
  },
  color: {
    active: 'white',
    inactive: colors.blue[900],
  },
};

theme.survey = {
  page: {
    color: colors.blue[900],
    shadow: '0px 8px 12px #ccc',
    background: 'white',
    borderColor: colors.blue[100],
  },
  question: {
    color: colors.blue[700],
    background: colors.blue[100],
    borderColor: colors.blue[100],
    borderRadius: '8px',
    answerColor: colors.blue[900],
    padding: {
      large: '1.875rem',
      small: '0.875rem',
    },
    shadow:
      '0px 16px 28px -3px hsla(222, 83%, 34%, 0.27), 0px 4px 4px 0px hsla(222, 83%, 34%, 0.15)',
    completed: {
      color: colors.green[700],
      background: colors.green[100],
      borderColor: colors.green[100],
    },
  },
};

/** The anonymous survey page (containers/GenericSurvey). Not the old survey above. */
theme.genericSurvey = {
  border: colors.gray[100],
  card: {
    background: '#fff',
    shadow: '0 4px 14px rgba(13, 48, 130, 0.08)',
  },
  input: {
    background: '#fff',
  },
  loader: colors.blue[900],
  option: {
    hoverBorder: colors.blue[300],
    selectedBackground: colors.blue[25],
    selectedBorder: colors.blue[600],
  },
  page: {
    background: colors.blue[50],
  },
  progress: {
    bar: colors.blue[700],
    rail: colors.gray[100],
  },
  rating: {
    selectedBackground: colors.blue[50],
    selectedColor: colors.blue[600],
  },
  text: {
    muted: colors.gray[600],
    primary: colors.blue[900],
    question: colors.blue[900],
    title: colors.blue[900],
  },
  thankYou: {
    iconBackground: colors.green[50],
    iconColor: colors.green[600],
  },
};

theme.welcomePackage = {
  background: 'white',
  textColor: colors.blue[900],
  timer: {
    color: colors.blue[900],
    borderColor: colors.blue[500],
    borderRadius: '12px',
  },
  banner: {
    background: {
      packages: colors.blue[50],
      bundle: 'transparent',
    },
    borderColor: colors.blue[200],
  },
};

theme.yellowUnderline = colors.yellow[300];

theme.sideMenu = {
  highlight: colors.yellow[200],
};

/**
 * Smart sort summary card as rendered in the single application view (design 2b).
 * Text colours are picked to track the design's contrast against the card, not just
 * its hue: title 12.2:1 (design 16.3:1), body 6.3:1 (design 5.9:1), muted 4.1:1.
 */
theme.smartSortSummary = {
  background: theme.background.panelSecondary,
  borderColor: colors.gray[100],
  titleColor: colors.gray[900],
  bodyColor: colors.gray[700],
  mutedColor: colors.gray[600],
};

theme.applicationsList = {
  header: {
    height: '52px',
  },
  rating: {
    popover: {
      titleColor: colors.blue[700],
      starsBackground: colors.gray[50],
      userStarsBackground: 'white',
      userBackground: colors.blue[50],
      borderColor: colors.blue[50],
    },
  },
  singleApplication: {
    default: {
      phoneColor: colors.fuchsia[600],
    },
    selected: {
      background: colors.blue[500],
      phoneColor: colors.blue[100],
      rejected: {
        applicantName: colors.gray[100],
      },
    },
  },
};

theme.popoverButton = {
  color: theme.text.primary,
  backgroundColor: '#fff',
  borderColor: theme.text.primary,
  shadow: '0px 3px 6px -4px #537bd51f, 0px 6px 16px 0px #537bd514, 0px 9px 28px 8px #537bd50d',
};

theme.scheduledActions = {
  accent: colors.green[500],
  idle: colors.gray[400],
  category: {
    rejection: colors.fuchsia[600],
    interview: colors.blue[600],
    thankYou: colors.green[600],
    other: colors.gray[500],
  },
  glow: transparentize(0.4, colors.green[500]),
  badgeText: '#FFFFFF',
  flightIcon: '#FFFFFF',
  flightShadow: `0 6px 18px ${transparentize(0.5, colors.green[700])}`,
  rowBackground: '#FFFFFF',
  rowBorder: colors.blue[100],
  iconBackground: colors.green[50],
  text: colors.blue[950],
  textMuted: colors.gray[600],
};

// Tab that pulls the right sidebar over the application while it is maximized.
theme.rightSidebarHandle = {
  background: '#fff',
  border: colors.blue[100],
  color: theme.text.primary,
  focusRing: colors.blue[300],
  hover: {
    background: colors.blue[50],
    color: colors.blue[600],
  },
  shadow: '-4px 0px 16px -8px #537bd559, -1px 0px 4px -2px #537bd52e',
};

theme.newsFeedItem = {
  flashingBackgroundColor: colors.blue[100],
  unread: {
    background: {
      default: colors.blue[50],
      hover: colors.blue[50],
    },
    title: theme.text.primary,
    content: colors.grayDark[400],
    border: '2px solid transparent',
    icon: {
      default: colors.fuchsia[600],
    },
  },
  read: {
    background: {
      default: '#fff',
      hover: colors.blue[50],
    },
    title: colors.gray[600],
    content: colors.gray[600],
    border: `2px solid ${colors.gray[100]}`,
    icon: {
      default: colors.gray[700],
      hover: theme.text.primary,
    },
  },
};

theme.notificationItem = {
  title: colors.grayDark[400],
  date: colors.gray[500],
  content: colors.gray[500],
  border: {
    hover: colors.blue[800],
  },
  unread: {
    background: {
      default: colors.blue[50],
      hover: colors.blue[50],
    },
  },
  read: {
    background: {
      default: '#fff',
      hover: colors.blue[50],
    },
  },
};

theme.animatedBanner = {
  background: 'rgba(255, 255, 255, 0.25)',
  yellow: colors.yellow[200],
  purple: colors.purple[200],
};

theme.calendar = {
  slot: {
    accepted: {
      backgroundColor: colors.blue[100],
      textColor: colors.blue[800],
      separatorColor: colors.blue[700],
      highlightColor: colors.blue[150],
      iconColor: colors.blue[800],
    },
    rejected: {
      backgroundColor: '#FBE4EA',
      textColor: colors.fuchsia[600],
      separatorColor: colors.fuchsia[600],
      highlightColor: '#F7C9D580',
      iconColor: colors.fuchsia[600],
    },
    cancelled: {
      backgroundColor: '#FBE4EA',
      textColor: colors.fuchsia[600],
      separatorColor: colors.fuchsia[600],
      highlightColor: '#F7C9D580',
      iconColor: colors.fuchsia[600],
    },
    action_required: {
      backgroundColor: colors.yellow[100],
      textColor: colors.yellow[800],
      separatorColor: colors.yellow[600],
      highlightColor: '#FFE5A099',
      iconColor: colors.yellow[800],
    },
    pending: {
      backgroundColor: colors.blue[100],
      textColor: colors.blue[800],
      separatorColor: colors.blue[700],
      highlightColor: colors.blue[150],
      iconColor: colors.gray[600],
    },
  },
  reason: {
    edit: {
      backgroundColor: colors.yellow[50],
      accentColor: colors.yellow[700],
    },
    reject: {
      backgroundColor: colors.red[50],
      accentColor: colors.red[500],
    },
    cancel: {
      backgroundColor: colors.blue[50],
      accentColor: colors.blue[900],
    },
  },
  previewStatus: {
    accepted: {
      textColor: colors.green[800],
      borderColor: colors.green[200],
      backgroundColor: colors.green[50],
    },
    pending: {
      textColor: colors.blue[700],
      borderColor: colors.blue[150],
      backgroundColor: colors.blue[50],
    },
    rejected: {
      textColor: colors.fuchsia[700],
      borderColor: colors.red[100],
      backgroundColor: colors.red[50],
    },
    cancelled: {
      textColor: colors.fuchsia[700],
      borderColor: colors.red[100],
      backgroundColor: colors.red[50],
    },
    action_required: {
      textColor: colors.yellow[900],
      borderColor: colors.yellow[200],
      backgroundColor: colors.yellow[50],
    },
  },
};

theme.promoCodeInput = {
  background: colors.gray[50],
  color: colors.blue[900],
  borderColor: colors.gray[200],
  inputBackground: 'white',
  inputColor: 'inherit',
};

const sidemenuCardGradient = `linear-gradient(120deg, ${colors.blue[25]} 33%, ${colors.fuchsia[50]} 100%)`;

theme.packagesSidemenu = {
  card: {
    default: {
      background: colors.blue[50],
      color: colors.blue[900],
      borderColor: colors.blue[200],
      chervonColor: colors.blue[400],
    },
    hover: {
      background: sidemenuCardGradient,
      color: colors.fuchsia[600],
      borderColor: colors.fuchsia[600],
      chervonColor: colors.fuchsia[600],
    },
    active: {
      background: sidemenuCardGradient,
      color: colors.blue[900],
      borderColor: colors.blue[600],
      chervonColor: colors.blue[900],
    },
  },
  dropdown: {
    background: colors.blue[150],
    color: colors.blue[700],
    borderColor: colors.blue[200],
    iconHoverColor: colors.fuchsia[600],
  },
  confirmPulse: {
    ringStrong: `color-mix(in srgb, ${colors.blue[400]} 55%, transparent)`,
    ringSoft: `color-mix(in srgb, ${colors.blue[400]} 28%, transparent)`,
  },
};

theme.orderedPackages = {
  color: colors.blue[900],
  borderColor: colors.blue[150],
  header: {
    background: colors.blue[50],
  },
  footer: {
    background: colors.blue[100],
  },
};

theme.packageOrderForm = {
  sectionTitleColor: colors.blue[900],
  adLengthLabelColor: colors.gray[600],
  descriptionColor: theme.palette.foreground[100],
  cta: {
    background: colors.fuchsia[600],
    hoverBackground: colors.fuchsia[700],
    activeBackground: colors.fuchsia[800],
    focusRing: colors.fuchsia[600],
  },
};

theme.packagesBanner = {
  background: theme.palette.primary[29],
  titleColor: colors.blue[900],
};

theme.packageCard = {
  color: colors.blue[900],
  topBackground: colors.blue[50],
  background: 'white',
  borderColor: colors.blue[200],
  seperatorColor: colors.gray[100],
  status: {
    active: {
      color: colors.blue[800],
      background: colors.green[100],
    },
    pending: {
      color: colors.blue[800],
      background: colors.yellow[200],
    },
  },
};

theme.packagesOrderSummary = {
  shadow: '0 -1px 3px rgba(13, 48, 130, 0.1), 0 -10px 24px rgba(13, 48, 130, 0.05)',
  slider: {
    background: colors.blue[50],
    color: colors.blue[900],
    borderColor: colors.blue[200],
  },
  summary: {
    background: colors.blue[100],
    hoverBackground: colors.blue[150],
    color: colors.blue[900],
    borderColor: colors.blue[200],
    action: colors.blue[400],
  },
  ribbon: {
    background: colors.blue[50],
    color: colors.blue[900],
    borderColor: colors.blue[50],
    badgeBackground: colors.fuchsia[600],
    shadow: '0 -3px 8px rgba(13, 48, 130, 0.07)',
  },
  freshRow: {
    background: colors.blue[150],
  },
  fx: {
    rippleColor: colors.blue[400],
    splashColor: colors.blue[200],
    // pageFlash: reserved for the add-to-cart background flash (designer asset pending)
  },
};

theme.packagesNavigation = {
  mobile: {
    default: {
      color: colors.blue[950],
      borderColor: colors.gray[300],
    },
    selected: {
      color: colors.fuchsia[600],
      borderColor: colors.fuchsia[600],
    },
    hover: {
      background: colors.blue[50],
    },
  },
};

theme.quickFilter = {
  background: {
    default: colors.blue[50],
    selected: colors.blue[100],
    negative: colors.red[100],
  },
  color: {
    default: colors.blue[600],
    negative: colors.red[600],
  },
  border: {
    default: colors.blue[200],
    selected: colors.blue[600],
    negative: colors.red[600],
  },
};

theme.dailyChart = {
  addonRectColors: {
    social_posting_poslovi_fb: colors.purple[500],
    social_posting_poslovi_instagram: colors.fuchsia[400],
    social_posting_helloworld_fb: colors.purple[500],
    social_posting_helloworld_instagram: colors.fuchsia[400],
    top_result: colors.yellow[500],
    highlighted_ad: colors.blue[600],
  },
  addonDateRangeColors: {
    social_posting_poslovi_fb: colors.purple[300],
    social_posting_poslovi_instagram: colors.fuchsia[200],
    social_posting_helloworld_fb: colors.purple[300],
    social_posting_helloworld_instagram: colors.fuchsia[200],
    top_result: colors.yellow[200],
    highlighted_ad: colors.blue[200],
  },
};

theme.interviewQuestions = {
  hoverColor: colors.fuchsia[600],
  activeColor: colors.blue[400],
  tabs: {
    descriptionColor: colors.gray[600],
  },
  addQuestionSection: {
    otherLanguageBackground: {
      active: '#fff',
      hidden: colors.blue[50],
    },
    borderColor: colors.gray[100],
  },
  question: {
    background: colors.blue[25],
    color: colors.gray[600],
    ai: {
      background: 'linear-gradient(135deg, #EFF4FD, #DCD3F3)',
      color: colors.blue[500],
    },
    actions: {
      color: colors.blue[900],
      hoverColor: colors.fuchsia[600],
    },
    save: {
      color: colors.fuchsia[600],
    },
    title: {
      borderColor: colors.blue[100],
    },
    feedback: {
      color: colors.gray[600],
      hover: colors.fuchsia[600],
      active: colors.blue[400],
    },
    answer: {
      color: colors.grayDark[700],
    },
  },
};

theme.applicationsSelection = {
  background: colors.blue[25],
  header: {
    boxShadow: '1px 1px 2px #ccc',
    edit: {
      color: colors.blue[700],
    },
    count: {
      background: colors.blue[100],
      color: colors.blue[700],
    },
  },
  column: {
    background: colors.blue[50],
  },
  hiredPrompt: {
    title: {
      color: colors.gray[600],
    },
    dropZone: {
      activeBackground: colors.yellow[100],
      background: colors.yellow[50],
      border: colors.yellow[500],
      hint: {
        color: colors.gray[500],
      },
      icon: {
        background: colors.yellow[100],
        color: colors.yellow[500],
      },
      title: {
        color: colors.gray[700],
      },
    },
    motion: {
      card: '#fff',
      cursor: colors.gray[700],
      line: colors.gray[200],
      lineSoft: colors.gray[100],
      shadow: 'rgba(15, 58, 159, 0.22)',
    },
    notHired: {
      color: colors.gray[600],
    },
  },
  item: {
    name: {
      default: {
        color: colors.blue[900],
      },
      rejected: {
        color: colors.gray[600],
      },
      read: {
        color: colors.gray[900],
      },
    },
    phone: {
      color: colors.gray[600],
    },
    applicationTime: {
      color: colors.gray[400],
    },
    // The border-trace effect a card plays when it lands in Hired: `trace` draws the perimeter and
    // `head` is the point riding its leading edge.
    justHired: {
      glow: 'rgba(58, 165, 163, 0.26)',
      head: colors.green[300],
      trace: colors.green[500],
    },
    previousActions: {
      color: colors.gray[600],
    },
    quickActions: {
      boxShadow: '0px 16px 28px -3px #0f3a9f45',
    },
  },
};

theme.dashboard = {
  widget: {
    background: '#FFFFFF',

    jobList: {
      titleColor: colors.blue[900],
      linkColor: colors.fuchsia[600],
    },

    newsFeed: {
      titleColor: colors.blue[900],
      titleScrimColor: colors.blue[900],
      externalIconColor: colors.blue[900],
      externalIconBackground: 'rgba(239, 244, 253, 0.7)',
      emptyColor: colors.gray[600],
      overlayGradient:
        'linear-gradient(198.42deg, rgba(255, 229, 160, 0.1) 16.66%, rgba(255, 255, 255, 0.8) 64.45%, #E0EAFE 96.8%)',
    },

    jobPackageBalance: {
      titleColor: colors.blue[900],
      linkColor: colors.blue[900],
      linkBackground: colors.blue[50],
      cardBackground: colors.blue[50],
      iconBubbleBackground: '#FFFFFF',
      iconBubbleColor: colors.blue[800],
      packageNameColor: colors.blue[900],
      dateLineColor: colors.gray[600],
      progressTrack: colors.blue[100],
      progressFill: colors.blue[800],
      progressLabelColor: colors.gray[700],
      progressEndsColor: colors.gray[500],
      savingsBackground: colors.green[50],
      savingsText: colors.blue[900],
      renewPillBg: colors.blue[100],
      renewPillText: colors.blue[800],
      chartTitleColor: colors.gray[600],
      chartColumn: colors.blue[300],
      chartColumnActive: colors.blue[600],
      chartColumnEmpty: colors.gray[200],
      chartAxisLabel: colors.gray[500],
      chartTooltipBackground: colors.blue[900],
      chartTooltipText: '#FFFFFF',
      status: {
        active: { bg: colors.green[100], fg: colors.green[700] },
        soon: { bg: colors.nude[200], fg: colors.fuchsia[800] },
        expired: { bg: colors.gray[100], fg: colors.gray[700] },
      },
    },
  },
};

theme.quantityUpsell = {
  card: {
    background: colors.blue[25],
    border: colors.blue[150],
    shadow: 'none',
    color: colors.blue[900],
  },
  price: {
    color: colors.blue[700],
    currencyColor: colors.blue[500],
    label: colors.gray[600],
  },
  progress: {
    track: colors.blue[100],
    fill: colors.blue[600],
    label: colors.gray[600],
  },
  nudge: {
    color: colors.blue[800],
    bestColor: colors.green[700],
  },
  chip: {
    background: '#ffffff',
    border: colors.blue[100],
    shadow: 'none',
    numberColor: colors.blue[900],
    unitColor: colors.gray[500],
    focusRing: colors.blue[400],
    /* the same pair the ad-type option cards select with, so the two rows of
       choices on this page read as one control */
    selected: {
      background: theme.optionBox.background.selected,
      border: theme.optionBox.outline.selected,
    },
    pill: {
      rampFrom: colors.yellow[100],
      rampTo: colors.yellow[400],
      color: colors.blue[900],
    },
    micro: {
      suggested: colors.yellow[800],
    },
    check: {
      background: colors.blue[600],
      color: '#ffffff',
      shadow: 'none',
    },
  },
  stepper: {
    label: colors.gray[600],
    background: '#ffffff',
    buttonBorder: colors.blue[150],
    buttonBackground: '#ffffff',
    buttonColor: colors.blue[700],
    buttonHoverBorder: colors.blue[600],
    buttonHoverColor: colors.blue[800],
    buttonDisabledColor: colors.gray[300],
    valueBorder: colors.blue[150],
    valueColor: colors.blue[900],
    divider: colors.blue[100],
    focusRing: colors.blue[400],
  },
  total: {
    oldPrice: colors.gray[500],
    newPrice: colors.blue[950],
    currency: colors.gray[600],
    badgeBackground: colors.yellow[300],
    badgeColor: colors.blue[900],
  },
};

theme.hrReport = {
  card: {
    background: '#FFFFFF',
    border: colors.gray[100],
    shadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
    titleColor: colors.blue[900],
    subtitleColor: colors.gray[600],
  },
  kpi: {
    background: '#FFFFFF',
    shadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
    labelColor: colors.gray[600],
    valueColor: colors.blue[900],
    iconBackground: colors.blue[50],
    iconColor: colors.blue[600],
    delta: {
      positive: { color: colors.green[600], background: colors.green[50] },
      negative: { color: colors.red[600], background: colors.red[50] },
      neutral: { color: colors.gray[600], background: colors.gray[50] },
    },
  },
  funnel: {
    labelColor: colors.gray[800],
    trackBackground: colors.gray[100],
    countColor: '#FFFFFF',
    conversionColor: colors.gray[600],
    palette: [
      colors.blue[700],
      colors.blue[500],
      colors.purple[500],
      colors.fuchsia[500],
      colors.fuchsia[600],
    ],
  },
  barList: {
    labelColor: colors.gray[800],
    valueColor: colors.blue[900],
    trackBackground: colors.gray[100],
    defaultFill: colors.blue[500],
  },
  metricToggle: {
    trackBackground: colors.gray[100],
    itemColor: colors.gray[700],
    activeBackground: '#FFFFFF',
    activeColor: colors.blue[900],
    activeShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
  },
  table: {
    headerBackground: colors.gray[50],
    headerColor: colors.gray[600],
    rowBorder: colors.gray[100],
    cellColor: colors.gray[800],
    emphasisColor: colors.fuchsia[600],
    sortIconColor: colors.gray[400],
    sortIconActiveColor: colors.fuchsia[600],
    hoverBackground: colors.blue[25],
    headerHoverBackground: colors.gray[100],
    headerSortedBackground: colors.gray[100],
    cellSortedBackground: colors.gray[50],
  },
  search: {
    background: '#FFFFFF',
    border: colors.gray[200],
    hoverBorder: colors.blue[400],
    focusBorder: colors.blue[500],
    focusShadow: '0 0 0 2px rgba(83, 123, 213, 0.15)',
    color: colors.gray[800],
    placeholderColor: colors.gray[500],
    iconColor: colors.gray[400],
    iconHoverColor: colors.gray[600],
  },
  chart: {
    axisLabel: colors.gray[600],
    gridLine: colors.gray[100],
    tooltipBackground: colors.gray[900],
    tooltipColor: '#FFFFFF',
    areaGradientOpacity: 0.32,
    series: [
      colors.blue[700],
      colors.blue[500],
      colors.fuchsia[600],
      colors.purple[500],
      colors.green[600],
      colors.yellow[500],
    ],
  },
  emptyState: {
    color: colors.gray[500],
    iconColor: colors.gray[300],
  },
  skeleton: {
    /** Highlight band swept across loading placeholders — lighter than the flat track. */
    highlight: 'rgba(255, 255, 255, 0.72)',
  },
};

// Brand-coloured on purpose in both themes: the demo bar must read as "not part of the app".
theme.demoBar = {
  background: colors.blue[900],
  color: '#FFFFFF',
  shadow: '0 4px 16px rgba(13, 48, 130, 0.25)',
};

export default theme;
